/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import PropTypes from "prop-types";
import { fetchApiDataFailure } from '../../../../_actions/common.actions';

export default class DigitalPriceModal extends React.Component {

    static get propTypes() {
        return {
            getOverridePrice: PropTypes.func.isRequired,
            activeCollection: PropTypes.object.isRequired,
            updateOverridePrice: PropTypes.func.isRequired,
            getCollectionFromId: PropTypes.func.isRequired,
            collectionId: PropTypes.string.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            basePrice: "",
            calculatedPrice: "",
            specialPrice: "",
            calculatedPriceAmount: "",
            discountPercent: "",
            priceGroupId: "",
            saveDisabled : true,
            selectedRadio : "calculated",
        };
        this.updateOverridePrice = this.updateOverridePrice.bind(this);
        this.getOverridePrice = this.getOverridePrice.bind(this);
        this.handleDiscountChange = this.handleDiscountChange.bind(this);
        this.handleSpecialPriceChange = this.handleSpecialPriceChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.updateCalculatedAmount = this.updateCalculatedAmount.bind(this);
        this.validateDiscount = this.validateDiscount.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    componentDidMount() {
        if (this.props.collectionId) {
            this.getOverridePrice(this.props.collectionId);
        }
    }

    getOverridePrice(collectionId) {
        this.props.getOverridePrice(collectionId)
            .then(response => {
                this.setState({
                    basePrice: (response.data.basePrice).toFixed(2),
                    calculatedPrice: response.data.calculatedPrice,
                    specialPrice: response.data.specialPrice ? (response.data.specialPrice).toFixed(2) : "",
                    calculatedPriceAmount: response.data.calculatedPriceAmount ?
                        (response.data.calculatedPriceAmount).toFixed(2):(response.data.basePrice).toFixed(2),
                    discountPercent: response.data.discountPercent ? response.data.discountPercent : 0,
                    selectedRadio : response.data.specialPrice ? "special" : "calculated"
                });
            })
            .catch(error => {
                fetchApiDataFailure(error);
            });
    }
    
    getPriceGroupId() {
        const {code} = this.props.activeCollection.geo;
        let priceGroupId = "";
        
        if (code === 'US') {
            priceGroupId= "244f7f8e-1e6b-11e4-8276-03d31c1207ee";
        } else if (code === 'CA') {
            priceGroupId= "0492cecc-4df7-11e6-a6a1-122189a19418";
        }
        
        return priceGroupId;
    }
    updateOverridePrice() {
        let price = {
            basePrice: this.state.basePrice,
            calculatedPrice: this.state.selectedRadio === "calculated",
            specialPrice: this.state.specialPrice,
            calculatedPriceAmount: this.state.calculatedPriceAmount,
            discountPercent: this.state.discountPercent,
            priceGroupId: this.getPriceGroupId(),
            collectionId: this.props.collectionId
        };
        this.props.updateOverridePrice(price)
            .then(response => {
                this.props.getCollectionFromId(this.props.collectionId);
            })
            .catch(error => {
                fetchApiDataFailure(error);
            });
        this.props.closeModal();   
    }

    handleDiscountChange(e) {
        if( Number(e.currentTarget.value) <= 100) {
            this.setState({
                discountPercent: e.currentTarget.value,
                saveDisabled: false
            });
        }
    }

    handleSpecialPriceChange(e) {
        this.setState({
            specialPrice: e.currentTarget.value,
            saveDisabled: false
        });
    }

    handleOptionChange(e) {
        if (e.currentTarget.id === "calculated") {
            this.setState({
                calculatedPrice: true,
                selectedRadio: "calculated"
            });
        } else {
            this.setState({
                calculatedPrice: false,
                selectedRadio: "special"

            });
        }
    }

    updateCalculatedAmount(){
        this.setState({
            calculatedPriceAmount: (this.state.basePrice * (1 - this.state.discountPercent / 100)).toFixed(2)
        });
    }

    validateDiscount(e){
        if (['e', 'E', '-', '+'].includes(e.key)) {
            e.preventDefault();
        }
    }

    hideModal(){
        this.props.closeModal();
    }

    render() {
        return <div>
            <div className="price-modal-content">
                <div className="base-price-container">
                    <div className="pe-input-group">
                        <label className="pe-textLabelInput__label">Base price</label>
                        <div className="pe-input">
                            <button className="pe-btn" disabled={true}>$</button>
                            <input className="pe-textInput--basic base-price"
                                value={this.state.basePrice}
                                disabled={true}/>
                        </div>
                    </div>
                </div>
                <div className="discount-container">
                    <div className="pe-input-group">
                        <label className="pe-textLabelInput__label">Discount</label>
                        <div className="pe-input">
                            <button className="pe-btn" disabled={true}>%</button>
                            <input type="number"
                                className="pe-textInput--basic discount"
                                value={this.state.discountPercent !== 0 ? this.state.discountPercent : ""}
                                onChange={this.handleDiscountChange}
                                onBlur={this.updateCalculatedAmount}
                                onKeyPress={this.validateDiscount}/>
                        </div>
                    </div>
                </div>
                <div className="price-container-radio">
                    <div className="pe-radio">
                        <input type="radio" name="price-type" id="calculated"
                            checked={this.state.selectedRadio === "calculated"}
                            onClick={this.handleOptionChange}/>
                        <label className="pe-textLabelInput__label">Calculated price</label>
                    </div>
                    <div className="pe-radio special-price-radio">
                        <input type="radio" name="price-type" id="special"
                            checked={this.state.selectedRadio === "special"}
                            onClick={this.handleOptionChange}/>
                        <label className="pe-textLabelInput__label">Special price</label>
                    </div>
                </div>
                <div className="price-container-inputs">
                    <div className="pe-input">
                        <button className="pe-btn" disabled={true}>$</button>
                        <input className="pe-textInput--basic" id="calculated-price"
                            value={this.state.selectedRadio === "calculated" ? this.state.calculatedPriceAmount : ""}
                            disabled={true}/>
                    </div>
                    <div className="pe-input">
                        <button className="pe-btn" disabled={true}>$</button>
                        <input className="pe-textInput--basic" id="special-price"
                            value={this.state.selectedRadio === "special" ? this.state.specialPrice : ""}
                            onChange={this.handleSpecialPriceChange}/>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="pe-btn--btn_large btn-cancel" onClick={this.hideModal}>Cancel
                </button>
                <button
                    className={'pe-btn__primary--btn_large btn-action'.concat(this.state.saveDisabled ? ' save-btn-disable' : '')}
                    disabled= {this.state.saveDisabled}
                    onClick={this.updateOverridePrice}>
                    Save
                </button>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsComponents/DigitalPriceModal.js